import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { ErrorLogAnalysisReportDataService } from '../data-services/error-log-analysis-report-data.service';
import { ErrorLogAnalysisModel, ErrorLogAnalysisRequestModel, ErrorLogOccurrenceRequestModel, ErrorLogStatus, ErrorLogStatusUpdateModel } from '../business-entities/error-log-analysis-report.model';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogAnalysisReportService {

  constructor(private errorLogAnalysisReportDataService: ErrorLogAnalysisReportDataService) { }

  async GetErrorLogAnalysis(requestModel: ErrorLogAnalysisRequestModel): Promise<GenericResponse<any>> {
    return this.errorLogAnalysisReportDataService.getErrorLogAnalysis(requestModel);
  }

  // Sets the status of every ErrorLog record of the spike. Returns true when it was saved.
  async UpdateSpikeStatus(spike: ErrorLogAnalysisModel, status: ErrorLogStatus): Promise<boolean> {
    const requestModel: ErrorLogStatusUpdateModel = {
      controllerName: spike.controllerName,
      methodName: spike.methodName,
      windowStart: spike.windowStart,
      status: status
    };
    try {
      const res = await this.errorLogAnalysisReportDataService.updateErrorLogStatus(requestModel);
      return res?.responseObject === true;
    } catch {
      return false;
    }
  }

  async GetErrorLogOccurrences(requestModel: ErrorLogOccurrenceRequestModel): Promise<GenericResponse<any>> {
    return this.errorLogAnalysisReportDataService.getErrorLogOccurrences(requestModel);
  }
}
